(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroMuteToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button?.addEventListener('click', this.toggle.bind(this));
    }

    toggle() {
      const grid = this.closest('.hero__media-grid');
      if (!grid || !this.button) return;

      const isCurrentlyUnmuted = this.button.getAttribute('aria-pressed') === 'true';
      const nextUnmuted = !isCurrentlyUnmuted;

      grid.querySelectorAll('video').forEach((video) => {
        video.muted = !nextUnmuted;
        if (nextUnmuted) {
          video.play().catch(() => {});
        }
      });

      this.button.setAttribute('aria-pressed', String(nextUnmuted));
    }
  }

  if (!customElements.get('hero-mute-toggle')) {
    customElements.define('hero-mute-toggle', HeroMuteToggle);
  }

  class HeroVideoLightbox extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.wrapper = this.querySelector('.hero-video-lightbox__video-wrapper');
      this.closeButton = this.querySelector('.hero-video-lightbox__close');

      this.closeButton?.addEventListener('click', this.close.bind(this));
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog?.addEventListener('close', this.reset.bind(this));

      const grid = this.parentElement?.querySelector('.hero__media-grid');
      grid?.querySelectorAll('video.hero__media').forEach((video) => {
        video.addEventListener('dblclick', () => this.open(video));
      });
    }

    open(sourceVideo) {
      if (!this.dialog || !this.wrapper) return;

      this.reset();

      const video = /** @type {HTMLVideoElement} */ (sourceVideo.cloneNode(true));
      video.classList.remove('hero__media');
      video.classList.add('hero-video-lightbox__video');
      video.muted = false;
      video.controls = false;
      video.loop = true;
      video.autoplay = true;

      const applyAspectRatio = (source) => {
        if (source.videoWidth && source.videoHeight) {
          this.dialog.style.setProperty('--video-aspect-ratio', String(source.videoWidth / source.videoHeight));
        }
      };

      applyAspectRatio(sourceVideo);
      video.addEventListener('loadedmetadata', () => applyAspectRatio(video), { once: true });

      this.wrapper.appendChild(video);

      this.dialog.showModal();
      video.play().catch(() => {});
    }

    close() {
      this.dialog?.close();
    }

    reset() {
      if (!this.wrapper) return;
      this.wrapper.querySelector('video')?.pause();
      this.wrapper.innerHTML = '';
    }
  }

  if (!customElements.get('hero-video-lightbox')) {
    customElements.define('hero-video-lightbox', HeroVideoLightbox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
